export function isGuid(value?: string|null): any {
  return value && !!value.match(/^[\da-f]{8}-?([\da-f]{4}-?){3}[\da-f]{12}$/)?.[1]
}